import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { Notice } from 'app/shared/models/class/notice/notice';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-header-image-details',
  templateUrl: './header-image-details.component.html',
  styleUrls: ['./header-image-details.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class HeaderImageDetailsComponent extends SubscriptionBaseComponent implements OnInit {

  isDetailsOpen: boolean;
  isMobile = false;

  @Input() notice: Notice;
  @Output() goBack = new EventEmitter<boolean>()

  constructor(
    private breakpointObserver: BreakpointObserver,
    private mediaObserver: MediaObserver,
    private faIconService: FaiconService
  )
  {
    super();
  }

  ngOnInit(): void {
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  goback(): void {
    this.goBack.emit(false);
  }

  private initSub(): void {
    this.subscription
      .add(
        this.mediaObserver.asObservable().subscribe(() => {
          if (this.breakpointObserver.isMatched('(max-width: 600px)')) {
            this.isMobile = true;
          } else {
            this.isMobile = false;
          }
        })
      );

  }

}
